<template lang="pug">
.card-box
  h3.page-title.text-dark WebPファイル一括ダウンロード
  template(v-if="sent")
    .text-success ダウンロードの準備を開始しました。メールの到着をお待ちください。
  template(v-else)
    p
      | 変換後のWebPファイルを一括ダウンロードして今すぐ使えます！ →
      a.m-l-5(href="https://blog.ideamans.com/2019/02/webppagespeed-insights.html") 詳しい使い方はこちら
    .form-group
      label
        | メールアドレス
        span.badge.badge-danger.m-l-5 必須
      input.form-control(v-model.lazy="email" placeholder="your@example.com" lazy)
      small.text-hint
        | ZIPファイルの準備ができたらこのメールアドレスにダウンロードURLをお知らせします。

    .m-t-10
      button.btn.btn-primary(v-on:click="start" v-bind:disabled="!emailEnabled")
        i.mdi.mdi-download.m-r-5
        | WebPファイル一括ダウンロード
</template>

<script>
import Lib from '@/lib'

export default {
  props: {
    id: String,
  },
  data() {
    return {
      sent: false,
      email: '',
    }
  },
  methods: {
    async start() {
      const app = new Lib.App()
      const task = await app.sendNewPackTask({
        id: this.id,
        email: this.email,
      })
      this.sent = true
    }
  },
  computed: {
    emailEnabled() {
      return this.email != ''
    }
  },
  created() {
    this.email = window.localStorage.getItem('email') || ''
  },
  watch: {
    email() {
      window.localStorage.setItem('email', this.email)
    },
  }
}
</script>